/*
 * @Author: chengyu
 * @Date: 2022-09-29 15:09:31
 * @Description: 使用Taro工具中的请求方法
 */
// @ts-ignore
import EngineWrapper from 'flyio/dist/npm/engine-wrapper.js';
// @ts-ignore
import _Fly from 'flyio/dist/npm/fly.js';
// @ts-ignore
import adapter from './adapter/taro';
var engine = EngineWrapper(adapter);
export default (function () {
    return new _Fly(engine);
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFyby5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL3JlcXVlc3QvaHR0cC90YXJvLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7O0dBSUc7QUFHSCxhQUFhO0FBQ2IsT0FBTyxhQUFhLE1BQU0sa0NBQWtDLENBQUM7QUFDN0QsYUFBYTtBQUNiLE9BQU8sSUFBSSxNQUFNLHVCQUF1QixDQUFDO0FBRXpDLGFBQWE7QUFDYixPQUFPLE9BQU8sTUFBTSxnQkFBZ0IsQ0FBQztBQUVyQyxJQUFNLE1BQU0sR0FBRyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUM7QUFFdEMsZ0JBQWU7SUFDYixPQUFPLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0FBQzFCLENBQUMsRUFBQyJ9